import styled, { css } from 'styled-components'
import { StyledLanguageSelectorProps } from './LanguageSelector.types'

const sizeStyles = {
  small: css`
    min-width: 120px;

    .language-flag {
      font-size: 1rem;
    }

    .language-name {
      font-size: 0.75rem;
    }
  `,
  medium: css`
    min-width: 150px;

    .language-flag {
      font-size: 1.25rem;
    }

    .language-name {
      font-size: 0.875rem;
    }
  `,
  large: css`
    min-width: 180px;

    .language-flag {
      font-size: 1.5rem;
    }

    .language-name {
      font-size: 1rem;
    }
  `,
}

const variantStyles = {
  default: css`
    .language-display {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  `,
  compact: css`
    min-width: auto;

    .language-display {
      display: flex;
      align-items: center;
      gap: 0.25rem;
    }

    .language-name {
      display: none;

      @media (min-width: 768px) {
        display: block;
      }
    }
  `,
  'flag-only': css`
    min-width: auto;

    .language-display {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .language-name {
      display: none;
    }

    .language-code {
      display: none;
    }
  `,
}

export const LanguageSelectorWrapper = styled.div<StyledLanguageSelectorProps>`
  position: relative;
  display: inline-block;
  ${({ $size }) => sizeStyles[$size]}
  ${({ $variant }) => variantStyles[$variant]}
`

export const LanguageOption = styled.div`
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  width: 100%;
  justify-content: center;
`

export const LanguageFlag = styled.span`
  font-size: 1.25rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
`

export const LanguageInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`

export const LanguageName = styled.span`
  font-weight: 500;
  color: #1a1a1a;
  line-height: 1.2;
`

export const LanguageNativeName = styled.span`
  font-size: 0.75rem;
  color: #666;
  line-height: 1.2;
`

export const LanguageCode = styled.span`
  font-size: 0.75rem;
  color: #999;
  text-transform: uppercase;
  margin-left: auto;
`

export const CurrentLanguage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`

export const LanguageGroupHeader = styled.div`
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;

  &:first-child {
    border-top: none;
  }
`

export const PopularBadge = styled.span`
  font-size: 0.625rem;
  padding: 0.125rem 0.375rem;
  background-color: #0294df;
  color: white;
  border-radius: 3px;
  font-weight: 500;
  text-transform: uppercase;
  margin-left: 0.5rem;
`
